







































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import GeneralVehicleSelect from "@/components/scope/general-vehicle-select.vue";
import CheckListPrint from "./components/check-list-print.vue";
import DelegatePrint from "./components/delegate-print.vue";
import FileUpload from "@/components/scope/file-upload.vue";
import ExpandControl from "@/components/scope/expand-control.vue";
import dayjs from "dayjs";
import { priceRulesEl } from "@/utils/verify";

const testingItem = namespace("testing-item");
const user = namespace("user");
const store = namespace("store");
@Component({
  components: {
    GeneralVehicleSelect,
    FileUpload,
    ExpandControl,
    CheckListPrint,
    DelegatePrint
  }
})
export default class ServiceEdit extends Vue {
  @testingItem.Action getTestOrderDetail;
  @testingItem.Action completeTestOrder;
  @testingItem.Action cancelTestOrder;
  @testingItem.Action sendCheckReport;
  @user.State selectedOrgCode;
  @store.Action getStoreInfo;
  dayjs = dayjs;
  splitThousands = splitThousands;
  get breadData() {
    return [
      { name: window._I18N.t("test.testing-management"), path: "/test/index" },
      { name: window._I18N.t("test.test-details") }
    ];
  }
  get isAdd() {
    return true;
  }
  showSendReportTips: boolean = false;
  showPreviewPrint: boolean = false; // 显示检测打印单预览
  showDelegatePrint: boolean = false; // 显示委托打印单预览
  // 控制form disable状态
  formDisableStatus = {
    plateCode: false,
    customerModelCode: false,
    customerName: false,
    customerMobile: false
  };
  testOrderPrintObj: any = {
    id: "printMer1",
    popTitle: window._I18N.t("test.test-completion-sheet"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: window._I18N.t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  handleComplete() {
    // return false;
    let hasEmpty = false;
    this.testOrderData.checkItems.forEach(item1 => {
      item1.classSubItems.forEach(item2 => {
        item2.subItems.forEach(item3 => {
          if (item3.selectValueNos.length === 0) {
            hasEmpty = true;
            return;
          }
        });
      });
    });
    if (hasEmpty) {
      this.$message.error(window._I18N.t("test.incomplete-test"));
      return false;
    }
    this.completeTestOrder({
      checkOrderNo: this.testOrderId
    }).then(data => {
      this.$message.success(window._I18N.t("test.have-been-completed"));
      this.init();
    });
  }
  handleSendReport() {
    if (this.testOrderData.sendReportStatus === 1) {
      this.showSendReportTips = true;
      return false;
    }
    this.runSendCheckReport();
  }
  runSendCheckReport() {
    this.sendCheckReport({
      checkOrderNo: this.testOrderId
    }).then(data => {
      this.$message.success(window._I18N.t("test.report-sent-user-mobile-phone"));
      this.showSendReportTips = false;
      this.testOrderData.sendReportStatus = 1;
    });
  }
  handleReSendReport() {
    this.runSendCheckReport();
  }
  handleMoreMenuClick(command) {
    if (command === "printDelegate") {
      this.getStoreInfo({
        orgCode: this.selectedOrgCode
      }).then(data => {
        this.testOrderData.storeData = data.data;
        this.showDelegatePrint = true;
      });
    } else if (command === "printCheck") {
      this.getStoreInfo({
        orgCode: this.selectedOrgCode
      }).then(data => {
        this.testOrderData.storeData = data.data;
        this.showPreviewPrint = true;
      });
    } else {
      this.cancelTestOrder({
        checkOrderNo: this.testOrderId
      }).then(data => {
        this.$message.success(window._I18N.t("test.canceled"));
        this.init();
      });
    }
  }
  counselor: string = "";
  advisorList: any[] = [{}];

  defaultVehicleList: any[] = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  showAdditional: boolean = false;

  get bigTtemList() {
    return this.testOrderData.checkItems || [];
  }

  get testOrderId() {
    return this.$route.params.id;
  }

  created() {
    this.init();
  }

  testOrderData: any = {};
  async init() {
    this.getTestOrderDetail({
      checkOrderNo: this.testOrderId
    }).then(data => {
      data.data.checkOrderDetails.forEach((item, index) => {
        item.classSubItems.forEach(item2 => {
          item2.subItems.forEach(item3 => {
            const serviceCodeMap = {};
            item.recommendServiceArray &&
              item.recommendServiceArray.forEach(item => {
                serviceCodeMap[item.serviceCode] = item.serviceName;
              });
            item3.serviceCodeMap = serviceCodeMap;
            item3.images = item3.images ? item3.images : [];
            item3.selectValue = item3.selectValueNos ? item3.selectValueNos[0] : "";
            item3.selectValueNos = item3.selectValueNos || [];
            item3.excludeWarningLevels = item3.excludeWarningLevels || [];
          });
        });
        item.unfold = true; // 不折叠
        item.normalCount = 0; // 正常项数量
        item.seriousCount = 0; // 严重项数量
        item.warningCount = 0; // 预警项数量
        item.itemCount = 0; // 当前项目行数
        item.inputComplete = false; // 是否填写完成
      });
      data.data.customerOilVolume = Number(data.data.customerOilVolume);
      this.testOrderData = data.data;
      this.testOrderData.checkItems = data.data.checkOrderDetails;
      this.testOrderData.checkItems.forEach((item, index) => {
        this.checkBigItemComplete(index);
      });
    });
  }
  checkBigItemComplete(index) {
    let bigItemData = this.testOrderData.checkItems[index];
    let normalNum = 0;
    let seriousNum = 0;
    let warningNum = 0;
    let inputNum = 0;
    bigItemData.classSubItems.forEach(item => {
      item.subItems.forEach(item2 => {
        if (item2.valueType === "1") {
          // 检测项输入值类型
          if (item2.selectValue) {
            // 输入框有值
            inputNum += 1;
            if (!item2.selectWarningLevel) {
              // 没有匹配到valueOptions 就算严重
              seriousNum++;
            } else {
              let result = item2.valueOptions.find(valueOp => item2.selectWarningLevel === valueOp.warningLevel);
              if (result) {
                if (result.warningLevel === "1") {
                  seriousNum++;
                } else if (result.warningLevel === "2") {
                  warningNum++;
                } else {
                  normalNum++;
                }
              }
            }
          }
        } else {
          item2.selectValueNos.length && (inputNum += 1);
          item2.selectValueNos.forEach(item3 => {
            let result = item2.valueOptions.find(item4 => item4.valueNo === item3);
            if (result) {
              if (result.warningLevel === "1") {
                seriousNum++;
              } else if (result.warningLevel === "2") {
                warningNum++;
              } else {
                normalNum++;
              }
            }
          });
        }
      });
    });

    if (inputNum >= bigItemData.itemCount) {
      bigItemData.inputComplete = true;
      bigItemData.normalCount = normalNum;
      bigItemData.seriousCount = seriousNum;
      bigItemData.warningCount = warningNum;
    } else {
      bigItemData.normalCount = normalNum;
      bigItemData.seriousCount = seriousNum;
      bigItemData.warningCount = warningNum;
      bigItemData.inputComplete = false;
    }
  }
  handleSelectOption(row, valueNo) {
    console.log(row, valueNo);
    if (row.selectValueNo) {
      row.selectValueNo = valueNo;
    } else {
      this.$set(row, "selectValueNo", valueNo);
    }
  }
  handleValueInputEnd(row) {
    let valueList = row.valueOptions;
    for (let index = 0; index < valueList.length; index++) {
      const element = valueList[index];
      if (
        Number(row.selectValueNo) >= Number(element.minValue) &&
        Number(row.selectValueNo) <= Number(element.maxValue)
      ) {
        if (row.accordIndex) {
          row.accordIndex = index;
        } else {
          this.$set(row, "accordIndex", index);
        }
        return;
      }
    }
    row.accordIndex = null;
  }
  handleCreateOrderLink(command) {
    if (command === "maintenance") {
      const recommendServiceCodes = [];
      this.testOrderData.warningDetails.forEach(item => {
        item.recommendServiceArray.forEach(recommend => {
          recommendServiceCodes.push(recommend.serviceCode);
        });
      });
      this.$router.push(
        `/service/add?type=${command}&customerCode=${this.testOrderData.customerCode}&vehicleCode=${
          this.testOrderData.vehicleCode
        }&serviceItem=${recommendServiceCodes.join(",")}`
      );
    } else if (command === "retail") {
      this.$router.push(
        `/service/retail/add?customerCode=${this.testOrderData.customerCode}&vehicleCode=${this.testOrderData.vehicleCode}`
      );
    } else {
      this.$router.push(
        `/service/add?type=${command}&customerCode=${this.testOrderData.customerCode}&vehicleCode=${this.testOrderData.vehicleCode}`
      );
    }
  }
}
